import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigurationService } from '@draeger-academy/common/lib/services/configuration/configuration.service';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { EConnectionStatus } from '../../enums/connection-status.enum';
import { environment as env } from '../../../../../src/environments/environment';
import { AuthenticationService } from '../authentication/authentication.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    constructor(
        private _localizeRouterService: LocalizeRouterService,
        private router: Router,
        private authenticationService: AuthenticationService,
        private _configurationService: ConfigurationService
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (request.url && request.url.indexOf(env.APIEndpoint) === -1) {
            return next.handle(request);
        }
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                let errorMsg = '';
                if (error.error instanceof ErrorEvent) {
                    errorMsg = `Error: ${error.error.message}`;
                } else {
                    errorMsg = `Error Code: ${error.status},  Message:9 ${error.message}`;
                    if (error.status === EConnectionStatus.STATUS_404) {
                        if (request.url && request.url.indexOf('course/') >= 0 && !this._configurationService.isPartnerPage()) {
                            const translatedPath: any = this._localizeRouterService.translateRoute('/' + 'page-not-found');
                            this.router.navigate([translatedPath], { skipLocationChange: true });
                        }
                    } else if (error.status === EConnectionStatus.STATUS_403) {
                        localStorage.setItem('sessionExpired', 'true');
                        this.authenticationService.logout().then(() => {
                            this.authenticationService.redirectAfterLogout();
                        });
                    } else if (error.status === EConnectionStatus.STATUS_400 && error?.error === 'Wrong old password') {
                        return throwError(error);
                    } else {
                        if (this._localizeRouterService && error.status !== EConnectionStatus.STATUS_401) {
                            const translatedPath: any = this._localizeRouterService.translateRoute('/' + 'server-error-page');
                            this.router.navigate([translatedPath], { skipLocationChange: true });
                        }
                    }
                }
                return throwError(error);
            })
        );
    }
}
